var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("a-result", {
    staticClass: "error-page",
    attrs: {
      status: "403",
      title: "403",
      "sub-title": _vm.$t("对不起，你没有权限查看这个页面")
    },
    scopedSlots: _vm._u([{
      key: "extra",
      fn: function () {
        return [_c("a-button", {
          attrs: {
            type: "primary"
          },
          on: {
            click: _vm.returnHome
          }
        }, [_vm._v(" " + _vm._s(_vm.$t("返回首页")) + " ")])];
      },
      proxy: true
    }])
  });
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };